export const VALIDATION_MESSAGE = {
  get: function (title: string, validator: string, min?: number, max?: number) {
    switch (validator) {
      case "required":
        return `${title}を入力してください。`;
      case "uuid":
        return `${title}の形式が無効です。`;
      case "empty":
        return `${title}が空です。`;
      case "number":
        return `${title}は数値で入力してください。`;
      case "boolean":
        return `${title}はtrueまたはfalseである必要があります。`;
      case "min_max":
        return `${title}は${min}〜${max}文字で入力してください。`;
      case "max":
        return `${title}は${max}文字以内で入力してください。`;
      case "exact":
        return `${title}は${min}文字である必要があります。`;
      case "array":
        return `${title}は配列形式である必要があります。`;
      case "positive":
        return `${title}は正の数のみ入力可能です。`;
      case "max_number":
        return `${title}は${min}以下である必要があります。`;
      case "min_number":
        return `${title}は${min}以上である必要があります。`;
      case "lesser_than":
        return `${title}は${min}未満である必要があります。`;
      case "greater_than":
        return `${title}は${min}桁文字以上で入力してください。`;
      default:
        return `${title}が無効です。`;
    }
  },
};

export const GLOBAL_ERROR_MESSAGE = "エラーが発生しました。";
